export default function digital(podeAcessar) {
  return [
    {
      name: 'Inicio',
      icon: 'fa fa-th-large fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: true,
      link: '/app/digital/inicio',
    },
    {
      name: 'Conversas',
      icon: 'fa fa-comments fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('digital.conversas'),
      link: '/app/digital/conversas',
    },
    {
      name: 'WhatsApp',
      icon: 'fa fa-whatsapp fa-fw',
      type: 'collapse',
      ativo: podeAcessar('digital_agente_virtual'),
      children: [
        {
          name: 'Números Conectados',
          type: 'item',
          ativo: true,
          link: '/app/digital/whatsapp/numeros',
        },
        {
          name: 'Modelos de Mensagem',
          type: 'item',
          ativo: true,
          link: '/app/digital/whatsapp/templates',
        },
      ],
    },
    {
      name: 'Agente Digital',
      icon: 'fa fa-github-alt fa-fw',
      type: 'collapse',
      ativo: podeAcessar('digital_agente_virtual'),
      children: [
        {
          name: 'Agentes Digitais',
          type: 'item',
          ativo: true,
          link: '/app/digital/agente-virtual/agentes',
        },
        {
          name: 'Dashboard Agentes (Em breve)',
          type: 'item',
          ativo: false,
          link: '/app/digital/agente-virtual/painel',
        },
        {
          name: 'Parametrizações',
          type: 'item',
          ativo: true,
          link: '/app/digital/agente-virtual/config',
        },
        {
          name: 'Mailling',
          type: 'item',
          ativo: true,
          link: '/app/digital/agente-virtual/mailling',
        },
      ],
    },
    {
      name: 'Régua de Cobrança',
      icon: 'fa fa-registered fa-fw',
      ativo: podeAcessar('digital_regua_cobranca'),
      type: 'collapse',
      children: [
        {
          name: 'Parametrizações',
          type: 'item',
          ativo: true,
          link: '/app/digital/regua-de-cobranca/config',
        },
        {
          name: 'Eventos',
          type: 'item',
          ativo: true,
          link: '/app/digital/regua-de-cobranca/eventos',
        },
      ],
    },
    {
      name: 'Portal de Negociações',
      icon: 'zmdi zmdi-hc-fw zmdi-desktop-windows',
      type: 'collapse',
      ativo: podeAcessar('digital_portal_neg'),
      children: [
        {
          name: 'Parametrizações',
          type: 'item',
          ativo: true,
          link: '/app/digital/portal/config',
        },
        {
          name: 'Acessos',
          type: 'item',
          ativo: true,
          link: '/app/digital/portal/acessos',
        },
        {
          name: 'Customizações',
          type: 'item',
          ativo: true,
          link: '/app/digital/portal/customizacao',
        },
        {
          name: 'Domínio (white label)',
          type: 'item',
          ativo: true,
          link: '/app/digital/portal/dominio',
        },
      ],
    },
    {
      name: 'Portal do Credor',
      icon: 'zmdi zmdi-hc-fw zmdi-desktop-windows',
      type: 'collapse',
      ativo: podeAcessar('digital_portal_credor'),
      children: [
        {
          name: 'Acessos',
          type: 'item',
          ativo: true,
          link: '/app/digital/portal-credor/acessos',
        },
        {
          name: 'Customizações',
          type: 'item',
          ativo: true,
          link: '/app/digital/portal-credor/customizacao',
        },
        {
          name: 'Domínio (white label)',
          type: 'item',
          ativo: true,
          link: '/app/digital/portal-credor/dominio',
        },
        {
          name: 'Níveis de Acesso',
          type: 'item',
          ativo: true,
          link: '/app/digital/portal-credor/nivel-acesso',
        },
      ],
    },
  ];
}
